import { SxProps } from '@mui/material';
import Chip from '@mui/material/Chip';

const ComplexityChipColors = {
  Low: '#81C784',
  Medium: '#FFA726',
  High: '#F4433680',
};

type Props = {
  complexity: 'Low' | 'Medium' | 'High';
};

export const ComplexityChip = ({ complexity }: Props) => {
  const chipStyles: SxProps = {
    fontSize: '1.8rem',
    fontWeight: 400,
  };

  const chipLow: SxProps = {
    ...chipStyles,
    bgcolor: ComplexityChipColors.Low,
  };

  const chipMedium: SxProps = {
    ...chipStyles,
    bgcolor: ComplexityChipColors.Medium,
  };

  const chipHigh: SxProps = {
    ...chipStyles,
    bgcolor: ComplexityChipColors.High,
  };

  switch (complexity) {
    case 'Low':
      return <Chip label={complexity} sx={chipLow} />;
    case 'Medium':
      return <Chip label={complexity} sx={chipMedium} />;
    case 'High':
      return <Chip label={complexity} sx={chipHigh} />;
    default:
      return <Chip label={complexity} sx={chipStyles} />;
  }
};
